<template>
  <router-view />
</template>

<style>
h2,
p,
button,
a {
  font-family: aktiv-grotesk, Helvetica, Arial, sans-serif;
}

h2 {
  font-size: 32px;
  font-weight: 700;
}

p {
  font-size: 16px;
  line-height: 24px;
  overflow-wrap: break-word;
}

img {
  display: block;
  margin: 0 auto;
}

.landing-button {
  color: #fff;
  background-color: #000;
  border-color: #000;
  font-size: 1rem;
  line-height: 1.5;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  border-radius: 24px;
  padding: 12px 24px;
  max-width: 279px;
  width: 279px;
  height: 48px;
  border-style: solid;
  cursor: pointer;
  font-weight: 500;
  margin: 0 auto;
}
</style>
